import * as React from 'react';

import { cn } from '../../utils/cn';

const Input = React.forwardRef(({ className, type, error, ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(
                'flex h-9 w-full rounded-md border bg-[var(--background)] px-3 py-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
                'autofill:bg-[var(--background)] autofill:text-foreground autofill:shadow-[0_0_0_1000px_var(--background)_inset]',
                error
                    ? 'border-destructive focus-visible:border-destructive focus-visible:ring-[var(--ring-destructive)]'
                    : 'border-input focus-visible:border-ring focus-visible:ring-ring',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export { Input };
